module.exports = __webpack_public_path__ + "static/media/Xemelgo-Sticker-v1.eda8cc82.png";